import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
// import { Redirect } from "react-router-dom";
// import { errorPermission } from "../utilities/constantVariables";

// const axios = require('axios');

// Step-1: Create a new Axios instance with a custom config.
// The timeout is set to 10s. If the request takes longer than
// that then the request will be aborted.
export const customAxios = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_BASE_URL}/api/`,
  timeout: 10000,
  headers: {
    "content-type": "application/json",
  },
});

// Step-2: Create request, response & error handlers
const requestHandler = (request: AxiosRequestConfig) => {
  // Token will be dynamic so we can use any app-specific way to always
  // fetch the new token before making the call

  //request.headers.Authorization = `Bearer`;

  return request;
};

const responseHandler = (response: AxiosResponse<any>) => {
  // if (response.status === 401) {
  // window.location = '/login';
  //}
  return response?.data;
};

const errorHandler = (error: any) => {
  // window.location.href = errorPermission;

  return Promise.reject(error);
};

// Step-3: Configure/make use of request & response interceptors from Axios
// Note: You can create one method say configureInterceptors, add below in that,
// export and call it in an init function of the application/page.
customAxios.interceptors.request.use(
  (request) => requestHandler(request),
  (error) => errorHandler(error)
);

customAxios.interceptors.response.use(
  (response) => responseHandler(response),
  (error) => errorHandler(error)
);

type HTTPRequestConfig = AxiosRequestConfig;

const apiService = (axios: AxiosInstance) => {
  return {
    get: <T>(url: string, config: HTTPRequestConfig = {}) => {
      return axios.get<T>(url, config);
    },
    delete: <T>(url: string, config: HTTPRequestConfig = {}) => {
      return axios.delete<T>(url, config);
    },
    put: <T>(url: string, body: unknown, config: HTTPRequestConfig = {}) => {
      return axios.put<T>(url, body, config);
    },
    patch: <T>(url: string, body: unknown, config: HTTPRequestConfig = {}) => {
      return axios.patch<T>(url, body, config);
    },
    post: <T>(url: string, body: unknown, config: HTTPRequestConfig = {}) => {
      return axios.post<T>(url, body, config);
    },
  };
};
// Step-4: Export the newly created Axios instance to be used in different locations.
export const Http = apiService(customAxios);

//const res = await Http.get<UserDTO[]>("/users");
